/**
 * Neutral, accessible placeholder shown while the on-mount `/auth/me` probe is in
 * flight (status === 'probing'). Rendered by BOTH route guards so a deep-link or
 * refresh does not flash the sign-in screen (or protected content) before the
 * session is confirmed. `role="status"` + `aria-live="polite"` announce the wait
 * to assistive tech; the spinner itself is aria-hidden.
 */
import { Spinner } from '../components/Spinner';
import styles from './AuthLoading.module.css';

export function AuthLoading() {
  return (
    <div className={styles.loading} role="status" aria-live="polite">
      <Spinner />
      <span>Checking your session…</span>
    </div>
  );
}
